import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { useStore } from '../store';
import { supabase } from '../lib/supabase';
import { TopicCard } from './TopicCard';

export const FAQModal: React.FC = () => {
  const { isFaqModalOpen, setIsFaqModalOpen, faqs, setFaqs } = useStore();

  useEffect(() => {
    const fetchFAQs = async () => {
      // Get today's date at midnight
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const { data, error } = await supabase
        .from('faqs')
        .select('*')
        .gte('created_at', today.toISOString())
        .order('created_at', { ascending: false });

      if (error) {
        console.error('Error fetching FAQs:', error);
        return;
      }

      setFaqs(data.map(faq => ({
        id: faq.id,
        question: faq.question,
        bestTime: faq.best_time,
        explanation: faq.explanation,
        tip: faq.tip,
        created_at: faq.created_at,
        is_featured: faq.is_featured
      })));
    };

    if (isFaqModalOpen) {
      fetchFAQs();
    }
  }, [setFaqs, isFaqModalOpen]);

  if (!isFaqModalOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-white p-4 border-b flex justify-between items-center">
          <button
            onClick={() => setIsFaqModalOpen(false)}
            className="text-gray-500 hover:text-gray-700 transition-colors"
          >
            <X className="w-6 h-6" />
          </button>
          <h2 className="text-2xl font-bold text-gray-800">שאלות נפוצות מהיום 📊</h2>
        </div>
        
        <div className="p-6">
          <div className="grid gap-6">
            {faqs.map(faq => (
              <div key={faq.id} className="flex items-start gap-3">
                <span className="text-2xl" role="img" aria-label="chart">📈</span>
                <div className="flex-1">
                  <TopicCard topic={faq} />
                </div>
              </div>
            ))}
          </div>
          
          {faqs.length === 0 && (
            <div className="text-center text-gray-500 py-12">
              <p>אין שאלות נפוצות מהיום</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};